import { io, Socket } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

let socket: Socket | null = null;
let currentSession: { sessionId: string; participantId: string } | null = null;

export const getSocket = (): Socket => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 15,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
    });

    // При переподключении — автоматически re-join в комнату сессии
    socket.on('reconnect', () => {
      console.log('Socket reconnected');
      if (currentSession) {
        socket!.emit('join-session', currentSession);
      }
    });

    // Уведомление об ошибке подключения
    socket.on('connect_error', (err) => {
      console.warn('Socket connection error:', err.message);
    });
  }
  return socket;
};

export const connectSocket = (): Socket => {
  const s = getSocket();
  if (!s.connected) {
    s.connect();
  }
  return s;
};

export const disconnectSocket = (): void => {
  currentSession = null;
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const joinSession = (sessionId: string, participantId: string): void => {
  currentSession = { sessionId, participantId };
  const s = connectSocket();
  s.emit('join-session', { sessionId, participantId });
};

/** true если сокет подключён */
export const isConnected = (): boolean => {
  return socket?.connected ?? false;
};

/** Подписка на изменение статуса подключения */
export const onConnectionChange = (callback: (connected: boolean) => void): (() => void) => {
  const s = getSocket();
  const onConnect = () => callback(true);
  const onDisconnect = () => callback(false);

  s.on('connect', onConnect);
  s.on('disconnect', onDisconnect);

  return () => {
    s.off('connect', onConnect);
    s.off('disconnect', onDisconnect);
  };
};
